import './nav.less';
import PropTypes from 'prop-types';
import React from 'react';
import _get from 'lodash/get';
import { Link } from 'react-router';
import { baseUrl } from '../../../../config/route-entry-point';
import classname from 'classname';
import ContestHeader from './contest-header';

import { enum as affiliateLevels } from '../../../../../../enums/affiliate-levels';
const OPEN_TABS_FOR_REGISTERED_WITH_OFFER = [
	'finance', 'support', 'statistics', 'tools', 'streams', 'offers'
];

export default function Nav({ unreadMsgs, intl, user, location, userData }) {
	const isMaster = user && user.general && user.general.is_master;
	const links = getLinks(unreadMsgs, isMaster, intl, user, userData);
	const isNeedToShowBanner = _get(userData, 'contestConfig.isNeedToShowBanner', false);

	return (
		<div className="header-nav">
			<nav
				className={classname({
					'container font-proxima-nova-semibold': true,
					'child-affiliates-added': !!isMaster
				})}
			>
				<ul>{links}</ul>
			</nav>
			{
				isNeedToShowBanner && <ContestHeader intl={intl} userData={userData} />
			}
		</div>
	);
}

const getLinks = (unreadMsgs, isMaster, intl, user, userData) => {
	let data = [
		{
			className: 'statistics',
			title: intl('Статистика'),
			link: baseUrl('statistics/')
		},
		{
			className: 'offers',
			title: intl('Офферы'),
			link: baseUrl('offers/')
		},
		{
			className: 'streams',
			title: intl('Потоки'),
			link: baseUrl('campaigns/')
		},
		{
			className: 'tools',
			title: intl('Инструменты'),
			link: baseUrl('tools/'),
			preventDefault: true,
			dropdown: [
				{
					title: intl('API конверсий'),
					link: baseUrl('user-api/'),
					className: 'conversions-api'
				},
				{
					title: intl('API кабинета'),
					link: 'https://docs.everad.com',
					className: 'dashboard-api'
				},
				{
					title: intl('Дисконты и Бонусы'),
					link: baseUrl('discounts/'),
					className: 'discounts',
					shouldExclude: !['ru', 'en'].includes(user.general.language)
				},
				{
					title: intl('Мастер-Аккаунты'),
					link: baseUrl('master-account/'),
					className: 'conversions-api',
					shouldExclude: user.general.language !== 'ru'
				}/*,
				{
					title: intl('БМ Аккаунты'),
					link: baseUrl('bm-accounts/'),
					className: 'conversions-api'
				}*/
			]
		},
		{
			className: 'affiliates',
			title: intl('Вебмастера'),
			link: baseUrl('affiliates/'),
			shouldExclude: !isMaster
		},
		{
			className: 'finance',
			title: intl('Финансы'),
			link: baseUrl('finances/')
		},
		{
			className: 'news',
			title: intl('Новости'),
			link: baseUrl('news/')
		},
		{
			className: 'support',
			title: intl('Поддержка'),
			link: baseUrl('tickets/'),
			unread: unreadMsgs
		}
	];
	const isRegisteredLevel = userData.general.level === affiliateLevels.registered;
	const hasAvailableOffers = !!_get(userData, 'general.available_offers.length');

	return data.map((item, key) => {
		if (
			(isRegisteredLevel && hasAvailableOffers && !OPEN_TABS_FOR_REGISTERED_WITH_OFFER.includes(item.className))
			|| (isRegisteredLevel && !hasAvailableOffers && item.className !== 'support')
		) {
			return (
				!item.shouldExclude && (
					<li key={key}>
						<div className={classname({ [item.className]: true })}>
							<span className="title">
								{item.title}
								{item.unread > 0 && <span className="unread">{item.unread}</span>}
							</span>
						</div>
					</li>
				)
			);
		}
		const isActiveDropDown = item.dropdown && item.dropdown.some(item =>
			item.link.includes(window.location.pathname)
		);
		return (
			!item.shouldExclude && (
				<li key={key} className={item.dropdown && 'dropdown'}>
					<Link
						to={item.link}
						onClick={e => {
							item.preventDefault && e.preventDefault();
						}}
						className={classname({
							[item.className]: true,
							'active': isActiveDropDown,
							dropdown__head: !!item.dropdown
						})}
						activeClassName="active"
					>
						<span className="title">
							{item.title}
							{item.unread > 0 && <span className="unread">{item.unread}</span>}
						</span>
						{item.dropdown && <span className="dropdown-control" />}
					</Link>
					{item.dropdown && (
						<div className="dropdown_suggests">
							{item.dropdown.map((dropitem, i) => (
								!dropitem.shouldExclude && <div
									key={i}
									className={classname({
										[dropitem.className]: true,
										'dropdown_suggests-item': true,
										clearfix: true
									})}
								>
									<Link to={dropitem.link} target={dropitem.className === 'dashboard-api' ? '_blank' : null}>
										<span className="title">{dropitem.title}</span>
									</Link>
								</div>
							))}
						</div>
					)}
				</li>
			)
		);
	});
};

Nav.propTypes = {
	unreadMsgs: PropTypes.number,
	user: PropTypes.object,
	intl: PropTypes.func,
	location: PropTypes.object
};



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/everad/modules/header/nav.js